import React, { useState, useEffect } from "react";
import { obtenerDocumento } from "../services/uploadFile.service";
import { getAllFormulariosPorRequisito } from "../services/requisitos.service";
import { Grid, Typography } from "@mui/material";
import { COLORS } from "../config/theme";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import Loader from "./Loader";

export default function VerFormularios({
  setIsVisibleModal,
  setReload,
  reload,
  requisito,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [formularios, setFormularios] = useState([]);

  const onClose = () => {
    setIsVisibleModal(false);
  };

  useEffect(() => {
    loadFormularios();
  }, [requisito]);

  const loadFormularios = async () => {
    setIsLoading(true);
    const result = await getAllFormulariosPorRequisito(requisito.id_requisito, requisito.id_mov );
    setFormularios(result.data);
    setIsLoading(false);
  };

  const abrirDocumento = async (key) => {
    try {
      const response = await obtenerDocumento(key);

      if (response) {
        const signedUrl = response.url;
        const resultURL = signedUrl.split("?");

        window.open(resultURL[0], "_blank");
      } else {
        console.error("Error obteniendo documento");
        // TODO: Mostrar mensaje en pantalla
      }
    } catch (error) {
      console.error("Failed to get signed URL", error);
    }
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Grid container>
            {formularios.map((row) => (
              <Grid item xs={6}>
                <div
                  key={row.id} // Asegúrate de que cada elemento tenga una clave única
                  onClick={() => abrirDocumento(row.url)}
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    cursor: "pointer",
                    color: COLORS.PRIMARY,
                  }}
                >
                  <DescriptionOutlinedIcon style={{ fontSize: 40 }} />
                  <Typography variant="body2">{row.nombre}</Typography>
                </div>
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </>
  );
}
